var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPajamasMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 59.0927,
    height: 59.0927,
    rx: 17.3802,
    fill: "#C17B31"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.84992,
    clipPath: "url(#clip0_239_55)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M37.992 11.2971H21.1794C15.0526 11.2971 11.5813 14.7684 11.5813 20.8952V37.6919C11.5813 43.8187 15.0526 47.29 21.1794 47.29H37.992C44.1189 47.29 47.5742 43.8187 47.5742 37.6919V20.8952C47.5742 14.7684 44.1189 11.2971 37.992 11.2971Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_239_55)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.125 18.4375H34.875C35.0905 18.4375 35.2972 18.5231 35.4495 18.6755C35.6019 18.8278 35.6875 19.0345 35.6875 19.25V38.75C35.6875 38.9655 35.6019 39.1722 35.4495 39.3245C35.2972 39.4769 35.0905 39.5625 34.875 39.5625H25.125C24.9095 39.5625 24.7029 39.4769 24.5505 39.3245C24.3981 39.1722 24.3125 38.9655 24.3125 38.75V19.25C24.3125 19.0345 24.3981 18.8278 24.5505 18.6755C24.7029 18.5231 24.9095 18.4375 25.125 18.4375ZM21.875 19.25C21.875 18.388 22.2174 17.5614 22.8269 16.9519C23.4364 16.3424 24.2631 16 25.125 16H34.875C35.737 16 36.5636 16.3424 37.1731 16.9519C37.7826 17.5614 38.125 18.388 38.125 19.25V38.75C38.125 39.612 37.7826 40.4386 37.1731 41.0481C36.5636 41.6576 35.737 42 34.875 42H25.125C24.2631 42 23.4364 41.6576 22.8269 41.0481C22.2174 40.4386 21.875 39.612 21.875 38.75V19.25ZM30 37.125C30.431 37.125 30.8443 36.9538 31.1491 36.649C31.4538 36.3443 31.625 35.931 31.625 35.5C31.625 35.069 31.4538 34.6557 31.1491 34.351C30.8443 34.0462 30.431 33.875 30 33.875C29.569 33.875 29.1557 34.0462 28.851 34.351C28.5462 34.6557 28.375 35.069 28.375 35.5C28.375 35.931 28.5462 36.3443 28.851 36.649C29.1557 36.9538 29.569 37.125 30 37.125Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.0968 35.7097C32.0968 36.2658 31.8759 36.7991 31.4827 37.1923C31.0894 37.5856 30.5561 37.8065 30 37.8065C29.4439 37.8065 28.9106 37.5856 28.5174 37.1923C28.1242 36.7991 27.9032 36.2658 27.9032 35.7097C27.9032 35.1536 28.1242 34.6203 28.5174 34.227C28.9106 33.8338 29.4439 33.6129 30 33.6129C30.5561 33.6129 31.0894 33.8338 31.4827 34.227C31.8759 34.6203 32.0968 35.1536 32.0968 35.7097Z",
    fill: "#C17B31"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_239_55"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36.4985,
    height: 36.4985,
    fill: "white",
    transform: "translate(11.297 11.2971)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_239_55"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(14 13)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPajamasMobile);
export default __webpack_public_path__ + "static/media/pajamas_mobile.c4f9d41e70b0ae875ff6a4d785312209.svg";
export { ForwardRef as ReactComponent };